import { createSlice} from "@reduxjs/toolkit";
import { getApplicationLogo } from './thunk';

export const initialState = {
    logo: [],
    error: {},
};

const logoslice = createSlice({
    name: 'logo',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getApplicationLogo.fulfilled, (state, action) => {
            state.logo = action.payload;
        });
        builder.addCase(getApplicationLogo.rejected, (state, action) => {
            state.error = action.payload.error || null;
        });
    }
});

export default logoslice.reducer;